import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Analytics } from "@vercel/analytics/react";
import Header from "./Base/Header";
import Footer from "./Base/Footer";
import Events from "./Events/Events";
import EventsDynamic from "./EventsDynamic/EventsDynamic";
import OurEvents from "./OurEvents/OurEvents";
import CES from "./CES/CES";
import UNGA from "./UNGA/UNGA";
import UNGA25 from "./UNGA25/UNGA";
import Cannes from "./Cannes/Cannes";
import DEAL from "./DEAL/DEAL";
import DEAL2025 from "./DEAL2025/DEAL";
import RSA from "./RSA/RSA";
import Blackhat from "./Blackhat/Blackhat";
import SISVIP from "./SISVIP/SISVIP";
import SISVIP25 from "./SISVIP25/SISVIP";
import IndustrialTech from "./IndustrialTech/IndustrialTech";
import IndustrialTechNew from "./IndustrialTechNew/IndustrialTechNew";
import IsraelDealPortal from "./IsraelDealPortalNew/IsraelDealPortalNew";
import DealmakersIB from "./DealmakersIB/DealmakersIB";
import SisOmni from "./SisOmni/SisOmni";
import SisDelegate from "./SisDelegate/SisDelegate";
import GIIS from "./GIIS/GIIS";
import LeadGen from "./LeadGen/LeadGen";
import LeadMagic from "./LeadMagic/LeadMagic";
import { setCookie } from "./utils";
import ApiService from "./services/ApiService";
import LoadingPage from "./Base/Loading";

const DYNAMIC_EVENT_REQUEST_TIMEOUT_MS = 4000;
const DYNAMIC_EVENT_FALLBACK_BY_PAGE_URL = {
  "social-innovation-summit-2026-welcome-reception": {
    calendarOptions: {
      title: "Social Innovation Summit 2026 Welcome Reception - Atlanta, June 1st",
      description:
        '<b>Social Innovation Summit 2026 Welcome Reception</b><br><br>\n\n<b>Prospect</b><br>\nGeorgia Aquarium (Arctic Room)<br>\n225 Baker St<br>\nAtlanta, GA 30313<br><br>\n\n<b>Monday, June 1st</b><br>\n4:30 - 6:30 pm: Cocktails & Networking<br><br>\n\n<b>Questions?</b><br>\n<i>Please feel free to reach out to Kayla Schoerie: <a href="mailto:kschoerie@landmarkventures.com">kschoerie@landmarkventures.com</a></i>',
      startDateTime: null,
      endDateTime: null,
      location: "Prospect",
      timeZone: "America/New_York",
      manuallyEdited: false,
      showAddToCalendarButton: false,
      organizerName: "Kayla Schoerie",
      organizerEmail: "kschoerie@landmarkventures.com",
    },
    signupEmail: {
      emailSendFrom: "kschoerie@landmarkventures.com",
      emailSendFromName: "Shawn Cui",
      emailSubject:
        "Thanks for Applying | Social Innovation Summit 2025 Welcome Reception",
      emailBody:
        '<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;">Hi {FirstName|"There"},</span>\n<br>\n<br>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;">Thank you for your interest in joining our Social Innovation Summit 2025 Welcome Reception!</span>\n<br>\n<br>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">A team member will reach out to you if you are accepted into an event.</span>\n<br>\n<br>\n<div>\n  <span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">Warm regards,</span>\n</div>\n<div>\n  <span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">Shawn</span>\n</div>\n<div style="font-family: arial,helvetica,sans-serif; font-size: 10pt">\n  <p>_______________________________________ <br>\n    <strong>Shawn Cui, CFA, FRM</strong>\n    <br>Landmark Ventures | Investment Banking Associate <br> 1460 Broadway, New York, NY 10036<br>\n    <br> Main: 212.268.8500 | Mobile: 585.210.6061<br>Email: <a href="mailto:kschoerie@landmarkventures.com">kschoerie@landmarkventures.com</a>    <br> \n    <br><a href="https://www.linkedin.com/in/xcuigmail/">LinkedIn</a> | <a href="https://calendly.com/shawncui/30min">Schedule a Meeting</a><br> _______________________________________\n</div>',
    },
    deniedEmail: {
      emailSendFrom: "kschoerie@landmarkventures.com",
      emailSendFromName: "Shawn Cui",
      emailSubject: "Social Innovation Summit 2025 Welcome Reception at capacity",
      emailBody:
        '<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;">Hi {FirstName|"There"},</span>\n<br>\n<br>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;">Thank you for your interest in joining Social Innovation Summit 2025 Welcome Reception. Unfortunately we are at capacity for this event and so are unable to accomodate you.</span>\n<br>\n<br>\n<div>\n  <span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">Warm regards,</span>\n</div>\n<div>\n  <span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">Shawn</span>\n</div>\n<div style="font-family: arial,helvetica,sans-serif; font-size: 10pt">\n  <p>_______________________________________ <br>\n    <strong>Shawn Cui, CFA, FRM</strong>\n    <br>Landmark Ventures | Investment Banking Associate <br> 1460 Broadway, New York, NY 10036<br>\n    <br> Main: 212.268.8500 | Mobile: 585.210.6061<br>Email: <a href="mailto:kschoerie@landmarkventures.com">kschoerie@landmarkventures.com</a>    <br> \n    <br><a href="https://www.linkedin.com/in/xcuigmail/">LinkedIn</a> | <a href="https://calendly.com/shawncui/30min">Schedule a Meeting</a><br> _______________________________________\n</div>',
    },
    approvedEmail: {
      emailSendFrom: "kschoerie@landmarkventures.com",
      emailSendFromName: "Shawn Cui",
      emailSubject: "CONFIRMATION | Social Innovation Summit 2025 Welcome Reception",
      emailBody:
        '<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;">Hi {FirstName|"There"},</span>\n<br>\n<br>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;">Thank you for your interest in joining our Social Innovation Summit 2025 Welcome Reception! We are delighted to confirm your participation for the following event: </span>\n<br>\n<br>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">\n<p>\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: arial,helvetica,sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>SOCIAL INNOVATION SUMMIT 2025 WELCOME RECEPTION</strong>\n      </span>\n      <br>\n      Thank you for your interest. John Kunschner, Head of Investment Banking at Landmark, will reach out directly to coordinate a time & place to meet.<br><br>\n    </li>\n  </ul>\n</p>\n</span>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">We will follow up shortly with your calendar invite(s). Looking forward to welcoming you there!</span>\n<br>\n<div>\n  <br>\n</div>\n<div>\n  <span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">Best,</span>\n</div>\n<div>\n  <span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">Shawn</span>\n</div>\n<div style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">\n  <p>_______________________________________ <br>\n    <strong>Shawn Cui, CFA, FRM</strong>\n    <br>Landmark Ventures | Investment Banking Associate <br> 1460 Broadway, New York, NY 10036<br>\n    <br> Main: 212.268.8500 | Mobile: 585.210.6061<br>Email: <a href="mailto:kschoerie@landmarkventures.com">kschoerie@landmarkventures.com</a>    <br> \n    <br><a href="https://www.linkedin.com/in/xcuigmail/">LinkedIn</a> | <a href="https://calendly.com/shawncui/30min">Schedule a Meeting</a><br> _______________________________________\n</div>',
    },
    _id: "69d572ca5298be9b92004821",
    title: "Social Innovation Summit 2026 Welcome Reception",
    pageUrl: "social-innovation-summit-2026-welcome-reception",
    referralUrls: [],
    googlePolicyOptions: false,
    rubrikPolicyOptions: false,
    apolloAutofill: false,
    registrationClosed: false,
    owners: [
      {
        _id: "69fd049aa7129ed643baada4",
        email: "kschoerie@landmarkventures.com",
        assignedTime: 1746041782,
      },
    ],
    pageContent: {
      eventImages: [
        "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1778077313-sis-welcome-2026-event-image-1.jpg",
      ],
      expectBullets: ["4:30 - 6:30 pm: Cocktails & Networking"],
      footerImages: [],
      _id: "69fd049aa7129ed643baadaa",
      headerLogos: [
        {
          _id: "69fd049aa7129ed643baada5",
          src: "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1778008192-sis-logo-2026-trimmed.png",
          scale: 101,
          yOffset: 0,
        },
      ],
      faqs: [
        {
          _id: "69fd049aa7129ed643baada6",
          question: "Is the event complimentary?",
          answer:
            "Yes, this networking reception is a complimentary opportunity to kick off Social Innovation Summit 2026.",
        },
        {
          _id: "69fd049aa7129ed643baada7",
          question: "Can I bring a plus-one?",
          answer: "Due to limited capacity, this event is invitation-only.",
        },
        {
          _id: "69fd049aa7129ed643baada8",
          question: "Who do I reach out to if I have further questions?",
          answer:
            "Please reach out to adijamco@landmarkventures.com if you have any questions ahead of the event.",
        },
        {
          _id: "69fd049aa7129ed643baada9",
          question: "How can I register for Social Innovation Summit 2026?",
          answer:
            "We'd love to have you at the Summit! Visit www.socialinnovation.com to register to attend.",
        },
      ],
      customQuestions: [],
      heroHeading: "Social Innovation Summit 2026 Welcome Reception",
      heroSubHeading:
        "Join us on the evening of Monday, June 1st at the Georgia Aquarium in Atlanta to kick off Social Innovation Summit 2026!",
      heroText:
        "Hosted in partnership with our friends at the Truist Foundation, this special networking reception takes place the evening before the summit. Connect with fellow attendees, spark new collaborations, and celebrate the vibrant community coming together for this year\u2019s event. Don\u2019t miss the opportunity to get a head start on the conversations that matter most before an amazing Social Innovation Summit 2026.",
      eventDate: "Monday, June 1st",
      eventTime: "4:30 - 6:30 pm EDT",
      eventLocationFull:
        "Georgia Aquarium (Arctic Room)\n225 Baker St\nAtlanta, GA 30313",
      eventLocationShort: "Atlanta, GA",
      expectText:
        "Please RSVP by May 26th to join! Upon registering, our team will follow up with a formal confirmation and calendar hold with more details.",
      afterSubmittedText:
        "A member of our team will be in touch shortly confirming your attendance. We can't wait to see you in Atlanta!",
      hideLandmarkHeaderLogo: true,
      hideLandmarkFooter: true,
      themePrimaryColor: "#ff12bb",
      textClass: "font-montserrat",
      headerTextClass: "font-league-spartan-bold",
      businessEmailsOnly: false,
      hideDietaryInput: false,
      showCustomInput: false,
      customInputRequired: false,
      customInputLabel: "Referred By",
      rsvpButtonText: "RSVP",
      registerButtonText: "Register",
    },
    eventId: "1bb805de",
    createdTime: 1775596234,
    googleSheetHeadersVersion: 2,
    __v: 10,
    sheetId: "1556807543",
  },
};

const cloneDynamicEventFallback = (pageUrl) => {
  const fallbackObj = DYNAMIC_EVENT_FALLBACK_BY_PAGE_URL[pageUrl];
  return fallbackObj ? JSON.parse(JSON.stringify(fallbackObj)) : null;
};

function RedirectToExternalURL({ url }) {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null;
}

export default function App() {
  // const homepage = process.env.REACT_APP_HOMEPAGE || "dynamic"; // temp should be ""
  const homepage = process.env.REACT_APP_HOMEPAGE || "";
  const [leadPage, setLeadPage] = useState(false);
  const [changeHead, setChangeHead] = useState(false);
  const [urlParams, setUrlParams] = useState(null);
  const [userId, setUserId] = useState(null);
  const [user, setUser] = useState({});
  const [preloadedEvent, setPreloadedEvent] = useState(null);
  const [dynamicEvent, setDynamicEvent] = useState(null);
  const [dynamicEventReferral, setDynamicEventReferral] = useState({});
  const [dynamicEventRoutePageUrl, setDynamicEventRoutePageUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  console.log("HOMEPAGE", homepage);
  console.log(`window.location.pathname`, window.location.pathname);
  console.log(`urlParams`, urlParams);

  const isOnDynamicEventPage =
    dynamicEvent && dynamicEvent.eventId ? true : false;

  // used for Cannes to preload the event // todo: generalize for all global events
  useEffect(() => {
    async function getPreloadedEventSisVip() {
      // use SISVIP event json obj instead of backend
      const preloadedObj = {
        preloaded: "true(this is arbitrary just for debug)",
        _id: {
          $oid: "681a14e239c607da88c8b0a4",
        },
        tags: ["global"],
        eventId: "b02e3f31",
        title: "SIS 2025 VIP Event Series",
        location: "San Francisco, CA",
        imageUrl:
          "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1746665716-sisomni-circle.png",
        startDate: "June 2",
        endDate: "June 4",
        startDateEpoch: 1748750400,
        endDateEpoch: 1748923200,
        options: [
          {
            logos: [
              "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1746802475-newprofit-logo-color-allwhite.png",
            ],
            _id: {
              $oid: "681a16f239c607da88c8b0d6",
            },
            title: "VIP Dinner: Step up to the Mic",
            description:
              "In partnership with New Profit, this special evening will bring together a dynamic Multiracial, Intergenerational, Cross-Sector (M.I.C.) community committed to expanding access and opportunity across America.\nWith a focus on philanthropic and corporate leaders, social entrepreneurs and innovators, and emerging leaders, the gathering will spotlight the voices driving systemic change in economic mobility, education, and democracy. Expect a meaningful space to connect, reflect, and activate shared progress.\n\nThis gathering also serves as a mini, momentum-building version of New Profit’s bi-annual convening, The Well.",
            location: "Waterbar",
            startTime: 1748858400,
            endTime: 1748869200,
            shortTitle:
              "Amplifying Cross-Sector Voices for an Evolving America",
            subLocation: "",
            timeString: "6:00 - 9:00pm PT",
            dateString: "Monday, June 2, 2025",
            timezone: "PT",
            optionId: "f63e56ac",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>VIP Dinner: Step up to the Mic</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Monday, June 2 | 6:00 PM – 9:00 PM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>Waterbar (Bridge Tower Room)</strong><br>\n        399 The Embarcadero<br>\n        San Francisco, California 94105<br><br>\n      </span>\n    </li>\n  </ul>\n</div>\n',
          },
          {
            logos: [
              "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1747240501-pwc_logo_rgb_colour_rev.png",
            ],
            _id: {
              $oid: "681a16f239c607da88c8b0d7",
            },
            title: "VIP Lunch: Building Human Skills for a Post-AI World",
            description:
              "Hosted with our friends at PwC, this exclusive lunch will welcome a curated group of senior corporate executives – along with select nonprofit and foundation leaders – to explore the critical importance of developing human-centered skills in an era defined by AI and game-changing technology.\n \nAs organizations accelerate digital transformation, leadership in the post-AI world will increasingly depend on skills like empathy, creativity, complex problem-solving, and systems thinking. Together, we'll discuss how companies are weaving volunteer engagement and social impact into professional development pathways, equipping their workforces with the emotional intelligence and strategic thinking needed to thrive in the future of work.",
            location: "Hyatt Regency",
            startTime: 1748925000,
            endTime: 1748928600,
            shortTitle: "",
            subLocation: "",
            timeString: "12:30 - 1:30pm PT",
            dateString: "Tuesday, June 3, 2025",
            timezone: "PT",
            optionId: "151eff9a",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>VIP Lunch: Building Human Skills for a Post-AI World</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Tuesday, June 3 | 12:30 PM – 1:30 PM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>Hyatt Regency (Marina Room)</strong><br>\n        5 Embarcadero Center<br>\n        San Francisco, CA 94111\n      </span>\n    </li>\n  </ul>\n</div>',
          },
          {
            logos: [],
            _id: {
              $oid: "681a18d439c607da88c8b0f4",
            },
            title: "VIP Dinner: Leaders & Luminaries",
            description:
              "This Social Innovation Summit signature, invitation-only event will bring together a powerful group of Fortune 500 executives, corporate & foundation leaders, entrepreneurs, influencers, and philanthropists in an environment designed to catalyze partnerships, inspire ideas, raise awareness, and build lasting relationships.",
            location: "La Mar Cocina Peruana",
            startTime: 1748944800,
            endTime: 1748955600,
            shortTitle: "",
            subLocation: "",
            timeString: "6:00 - 9:00pm PT",
            dateString: "Tuesday, June 3, 2025",
            timezone: "PT",
            optionId: "a8a6eb11",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>VIP Dinner: Leaders & Luminaries</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Tuesday, June 3 | 6:00 PM – 9:00 PM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>La Mar Cocina Peruana (City Room)</strong><br>\n        PIER 1 1/2 The Embarcadero N<br>\n        San Francisco, CA 94111\n      </span>\n    </li>\n  </ul>\n</div>',
          },
          {
            logos: [
              "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1746802577-mtves_showtime_lockup-white.png",
            ],
            _id: {
              $oid: "681a18d439c607da88c8b0f5",
            },
            title: "VIP Lunch: Mental Health, Media & the Role of Brands ",
            description:
              "Hosted in partnership with our friends at SHOWTIME/MTV Entertainment Studios, this exclusive lunch will welcome a curated group of brand leaders, corporate impact executives, media professionals, and changemakers for a powerful conversation on how brands are driving a cultural shift from mental health awareness to action.\n\nTogether, we’ll explore the role of brands and powerful cross-sector partnerships can shift the culture of mental health and inspire people to support themselves and others.",
            location: "Hyatt Regency",
            startTime: 1749011400,
            endTime: 1749015000,
            shortTitle: "",
            subLocation: "",
            timeString: "12:30 - 1:30pm PT",
            dateString: "Wednesday, June 4, 2025",
            timezone: "PT",
            optionId: "e067c4d8",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>VIP Lunch: Mental Health, Media & the Role of Brands</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Wednesday, June 4 | 12:30 PM – 1:30 PM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>Hyatt Regency (Bayview A Room)</strong><br>\n        5 Embarcadero Center<br>\n        San Francisco, CA 94111\n      </span>\n    </li>\n  </ul>\n</div>',
          },
          {
            logos: [
              "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1746802375-goodstack_white.png",
            ],
            _id: {
              $oid: "681a1a5e39c607da88c8b183",
            },
            title:
              "VIP Lunch: Embedding Purpose Into Work, Products, and Communities",
            description:
              "Hosted in partnership with our friends at Goodstack, this exclusive lunch will bring together social impact leaders for a conversation on the future of workplace giving, consumer donations, and corporate grantmaking — and the innovative tools helping companies empower the next generation of employees and consumers in meaningful ways.\n\nTogether, we’ll explore how forward-thinking companies are embedding giving into everyday digital experiences, from workplace tools to consumer products, creating new pathways for generosity, ecosystem engagement, and purpose at scale.",
            location: "Hyatt Regency",
            startTime: 1749011400,
            endTime: 1749015000,
            shortTitle: "",
            subLocation: "",
            timeString: "12:30 - 1:30pm PT",
            dateString: "Wednesday, June 4, 2025",
            timezone: "PT",
            optionId: "ec718a2f",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>VIP Lunch: Embedding Purpose Into Work, Products, and Communities</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Wednesday, June 4 | 12:30 PM – 1:30 PM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>Hyatt Regency (Golden Gate Room)</strong><br>\n        5 Embarcadero Center<br>\n        San Francisco, CA 94111\n      </span>\n    </li>\n  </ul>\n</div>',
          },
          {
            logos: [
              "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1747053921-white-myriadusa-symbol-tag-002.png",
            ],
            _id: {
              $oid: "681a1a9239c607da88c8b18f",
            },
            title: "VIP Lunch: Corporate Philanthropy in Times of Crisis",
            description:
              "Hosted in partnership with our friends at Myriad USA, this exclusive lunch will bring together a curated group of international corporate leaders, philanthropic advisors, and institutional funders to explore new models for global giving in an increasingly complex world.\n \nAs global challenges continue to intensify, companies are being called to respond quickly, thoughtfully, and strategically. Together, we’ll explore innovative approaches to international philanthropy, the infrastructure needed to drive scalable impact, and how U.S.-based donors and corporations can build agile, transparent models to support causes around the world.",
            location: "Hyatt Regency",
            startTime: 1749011400,
            endTime: 1749015000,
            shortTitle: "",
            subLocation: "",
            timeString: "12:30 - 1:30pm PT",
            dateString: "Wednesday, June 4, 2025",
            timezone: "PT",
            optionId: "3c8cd067",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>VIP Lunch: Corporate Philanthropy in Times of Crisis</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Wednesday, June 4 | 12:30 PM – 1:30 PM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>Hyatt Regency (Marina Room)</strong><br>\n        5 Embarcadero Center<br>\n        San Francisco, CA 94111\n      </span>\n    </li>\n  </ul>\n</div>',
          },
          {
            logos: [],
            _id: {
              $oid: "681a1aec39c607da88c8b19c",
            },
            title: "VIP Dinner: Leaders & Luminaries",
            description:
              "As we turn the page on another powerful chapter of SIS, this closing dinner will bring together a dynamic group of CSR & ESG executives, workforce and talent leaders, foundations, entrepreneurs, influencers, and philanthropists to celebrate a shared commitment to advancing economic mobility.\n\nTogether, we’ll raise a glass to another year of impact and to building more inclusive pathways to opportunity for all.",
            location: "Boulevard Restaurant",
            startTime: 1749031200,
            endTime: 1749042000,
            shortTitle: "",
            subLocation: "",
            timeString: "6:00 - 9:00pm PT",
            dateString: "Wednesday, June 4, 2025",
            timezone: "PT",
            optionId: "b7ff9df0",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>VIP Dinner: Leaders & Luminaries</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Wednesday, June 4 | 6:00 PM – 9:00 PM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>Boulevard Restaurant</strong><br>\n        1 Mission Street<br>\n        San Francisco, CA 94105\n      </span>\n    </li>\n  </ul>\n</div>',
          },
          {
            logos: [
              "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1746813468-aws_logo_rgb_1c_white.png",
            ],
            _id: {
              $oid: "681bc18235fec54155d834c5",
            },
            title: "VIP Dinner: Empowering Nonprofits Through Innovation",
            description:
              "Hosted in partnership with Amazon Web Services (AWS), this exclusive VIP dinner will convene senior leaders from across the nonprofit sector for a candid, peer-to-peer conversations on how technology is transforming mission delivery.\n\nYou’ll be in attendance with peers to explore how cloud solutions, AI, and emerging tech tools are helping organizations operate more efficiently, scale their impact, and meet the demands of a rapidly changing world. This evening is designed to inspire new ideas, share real-world examples, and highlight how tech-enabled strategies can empower nonprofits to do more, faster — all while networking with fellow changemakers and innovation leaders.",
            location: "PABU Izakaya",
            startTime: 1748944800,
            endTime: 1748955600,
            shortTitle: "",
            subLocation: "",
            timeString: "6:00 - 9:00pm PT",
            dateString: "Tuesday, June 3, 2025",
            timezone: "PT",
            optionId: "4f64a4a2",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>VIP Dinner: Empowering Nonprofits Through Innovation</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Tuesday, June 3 | 6:00 PM – 9:00 PM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>PABU Izakaya</strong><br>\n        101 California Street<br>\n        San Francisco, CA 94111\n      </span>\n    </li>\n  </ul>\n</div>',
          },
          {
            logos: [
              "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1746802409-lyft-logo_white.png",
            ],
            _id: {
              $oid: "681bc1e435fec54155d834ff",
            },
            title: "Welcome Reception",
            description:
              "Hosted in partnership with our friends at Lyft, this special networking reception takes place the evening before the conference. Connect with fellow attendees, spark new collaborations, and celebrate the vibrant community coming together for this year’s event. Don’t miss the opportunity to get a head start on the conversations that matter most before an amazing Social Innovation Summit 2025.",
            location: "Lyft HQ",
            startTime: 1748856600,
            endTime: 1748863800,
            shortTitle: "",
            subLocation: "",
            timeString: "5:30 - 7:30pm PT",
            dateString: "Monday, June 2, 2025",
            timezone: "PT",
            optionId: "b81ee603",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>Welcome Reception</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Monday, June 2 | 5:30 PM – 7:30 PM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>Lyft HQ</strong><br>\n        185 Berry Street<br>\n        San Francisco, CA 94107\n      </span>\n    </li>\n  </ul>\n</div>',
          },
          {
            logos: [
              "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1746802393-lululemon_core_lockup_white.png",
            ],
            _id: {
              $oid: "681bc26635fec54155d83512",
            },
            title: "Morning Yoga with lululemon",
            description:
              "Hosted in partnership with our friends at lululemon, we are pleased to announce that we will be hosting a complimentary morning yoga session on June 4th from 7:00am-8:00am PT at the Hyatt Regency San Francisco!\n\nStart your morning with this special class which includes sustainable lululemon yoga mats provided for guests to use and take home! This fun opportunity is on a first come first served basis so we encourage you to sign up as soon as possible using the form below.",
            location: "Hyatt Regency",
            startTime: 1748991600,
            endTime: 1748995200,
            shortTitle: "",
            subLocation: "",
            timeString: "7:00 - 8:00am PT",
            dateString: "Wednesday, June 4, 2025",
            timezone: "PT",
            optionId: "bb6774f4",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>Morning Yoga with lululemon</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Wednesday, June 4 | 7:00 AM – 8:00 AM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>Hyatt Regency (Waterfront Room)</strong><br>\n        5 Embarcadero Center<br>\n        San Francisco, CA 94111<br><br>\n        <span style="font-style: italic;">Sustainable yoga mats included!</span>\n      </span>\n    </li>\n  </ul>\n</div>',
          },
          {
            logos: [
              "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1747051221-bcg_logo_monogram_white.png",
            ],
            _id: {
              $oid: "681bc2af35fec54155d83523",
            },
            title:
              "VIP Lunch: Three Inflection Points Reshaping the Social Impact Landscape",
            description:
              "Hosted in partnership with the Boston Consulting Group, this exclusive gathering will bring together leading voices from across sectors for a forward-looking conversation on navigating today’s rapidly evolving environment. Together, we’ll explore three pivotal inflection points reshaping the future of social impact: navigating uncertainty, redefining narrative strategy amid volatility, and harnessing the power of AI to shape the next era of philanthropy.",
            location: "Hyatt Regency",
            startTime: 1748925000,
            endTime: 1748928600,
            shortTitle: "",
            subLocation: "",
            timeString: "12:30 - 1:30pm PT",
            dateString: "Tuesday, June 3, 2025",
            timezone: "PT",
            optionId: "a5d0c4f8",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>VIP Lunch: Reshaping the Social Impact Landscape</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Tuesday, June 3 | 12:30 PM – 1:30 PM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>Hyatt Regency (Golden Gate Room)</strong><br>\n        5 Embarcadero Center<br>\n        San Francisco, CA 94111\n      </span>\n    </li>\n  </ul>\n</div>',
          },
          {
            logos: [
              "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1747057426-partners-comcast-nbcuniversal-logo-white-650x241.avif",
            ],
            _id: {
              $oid: "681bc2ca35fec54155d83533",
            },
            title:
              "VIP Dinner: Powered by Connection- An Evening of Community & Impact",
            description:
              "Social Innovation Summit and Comcast are pleased to host an intimate dinner in San Bruno bringing together civic leaders, nonprofit partners, and business voices for an evening of connection, conversation, and shared purpose.\nThis gathering will spotlight the power of cross-sector collaboration to strengthen communities, spark innovation, and create lasting impact. Together, we’ll explore how business, government, and local changemakers can come together to drive inclusive growth and opportunity — in San Bruno and beyond.\n\nJoin us for a memorable evening alongside Comcast’s California leadership team and a curated group of community partners, as we build new relationships and celebrate what’s possible when we connect for good.",
            location: "Broadway Grill",
            startTime: 1748858400,
            endTime: 1748869200,
            shortTitle: "",
            subLocation: "",
            timeString: "6:00 - 9:00pm PT",
            dateString: "Monday, June 2, 2025",
            timezone: "PT",
            optionId: "263f322d",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>VIP Dinner: Powered by Connection – An Evening of Community & Impact</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Monday, June 2 | 6:00 PM – 9:00 PM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>Broadway Grill</strong><br>\n        1400 Broadway<br>\n        Burlingame, CA 94010\n      </span>  <br>\n      <br><span style="font-style: italic;">Please note, the location for this dinner is Burlingame (not downtown San Francisco)</span>\n    </li>\n  </ul>\n</div>',
          },
          {
            logos: [
              "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1747924170-apco-logo---primary-full-sig-white---for-digital-rgb.png",
            ],
            _id: {
              $oid: "681e22c435fec54155d87f63",
            },
            title: "VIP Lunch: Social Innovation Summit Leadership Council",
            description:
              "Amid shifting economic conditions, geopolitical uncertainty, domestic divisions, and accelerating climate challenges, a select group of Fortune 500 executives, foundation leaders, entrepreneurs, influencers, and philanthropists will convene to build relationships and shape solutions. \n\nTogether, we'll explore how leaders across CSR, ESG, and DEI can align strategies, share resources, and drive long-term, systemic impact in an increasingly interconnected and complex world.",
            location: "Hyatt Regency",
            startTime: 1748925000,
            endTime: 1748928600,
            shortTitle: "For SILC Members ",
            subLocation: "",
            timeString: "12:30 - 1:30pm PT",
            dateString: "Tuesday, June 3, 2025",
            timezone: "PT",
            optionId: "a9d8634b",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>VIP Lunch: Social Innovation Summit Leadership Council</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Tuesday, June 3 | 12:30 PM – 1:30 PM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>Hyatt Regency (Bayview A Room)</strong><br>\n        5 Embarcadero Center<br>\n        San Francisco, CA 94111\n      </span>\n    </li>\n  </ul>\n</div>',
          },
          {
            logos: [
              "https://betterblocks.landmarkventures.com:7770/uploads/landmark/misc/1746813468-aws_logo_rgb_1c_white.png",
            ],
            _id: {
              $oid: "6821e65140014efe6c2c1ecd",
            },
            title: "VIP Dinner: Building the Future of Nonprofit Innovation",
            description:
              "Join us for an intimate evening hosted in partnership with Amazon Web Services (AWS), bringing together technology leaders for a collaborative conversation on the evolving role of tech in the social impact world.\n\nThis dinner will serve as a gathering of peers to discuss real-world experiences and opportunities, allowing nonprofit leaders to directly inform how nonprofit technology partners can more effectively support their work — from cloud infrastructure and data analytics to responsible AI adoption. Whether you're building internal capacity or shaping sector-wide innovation, this is an opportunity for nonprofit tech leaders to meet technology partners, advance nonprofit missions, and support the future of tech for good.",
            location: "",
            startTime: 1749074400,
            endTime: 1749085200,
            shortTitle: "",
            subLocation: "",
            timeString: "6:00-9:00pm PT",
            dateString: "Wednesday, June 4, 2025",
            timezone: "PT",
            optionId: "784ae0ee",
            emailHtml:
              '<div style="margin: 20px 0;">\n  <ul class="glist" style="margin: 0; margin-left: 40px; padding: 0; font-family: Arial, sans-serif; color: #000000; font-size: 10pt; line-height: 16px;" type="disc">\n    <li>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt; color: #4472c4;">\n        <strong>VIP Dinner: Tech for Good</strong>\n      </span>\n      <br>\n      <span style="font-style: italic;">Wednesday, June 4 | 6:00 PM – 9:00 PM</span>\n      <br><br>\n      <span style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">\n        <strong>North Beach Restaurant (Wine Cellar)</strong><br>\n        1512 Stockton Street<br>\n        San Francisco, CA 94133\n      </span>\n    </li>\n  </ul>\n</div>',
          },
        ],
        createdTime: 1746539747,
        owners: [],
        __v: 72,
        approvedEmail: {
          emailSendFrom: "kschoerie@landmarkventures.com",
          emailSendFromName: "Kayla Schoerie",
          emailSubject: "CONFIRMATION | SIS 2025 VIP Event Series",
          emailBody:
            '<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;">Hi {FirstName|"There"},</span>\n<br>\n<br>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;">Thank you for your interest in joining SIS 2025 VIP Event Series! We are delighted to confirm your participation for the following event(s): </span>\n<br>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">{Events}</span>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">We will follow up shortly with a calendar request that includes all relevant logistical details.</span>\n<br>\n<br>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">Looking forward to welcoming you there!</span>\n<div>\n  <br>\n</div>\n<div>\n  <span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">Warm regards,</span>\n</div>\n<div>\n  <span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">Kayla</span>\n</div>\n<div style="font-family: arial,helvetica,sans-serif;">\n  <p>_______________________________________ <br>\n    <strong>Kayla Schoerie</strong>\n    <br>Landmark Ventures | Senior Marketing Manager <br> 1460 Broadway | New York, NY 10036 <br>\n    <br> Tel: 212.268.8500 | Cell: 203.856.7299 <br>Email: <a href="mailto:kschoerie@landmarkventures.com">kschoerie@landmarkventures.com</a>\n    <u>\n      <br>\n   _______________________________________\n</div>',
        },
        signupEmail: {
          emailSendFrom: "kschoerie@landmarkventures.com",
          emailSendFromName: "Kayla Schoerie",
          emailSubject:
            "Social Innovaton Summit 2025 VIP Event Series - San Francisco",
          emailBody:
            '<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;">Hi {FirstName|"There"},</span>\n<br>\n<br>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;">Thank you for registering to join our VIP Event Series during Social Innovation Summit 2025!</span>\n<br>\n<br>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">Our team will be in touch with confirmation details soon based on each event\'s capacity.</span>\n<br>\n<br>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">We look forward to an amazing time in San Francisco!</span>\n<br>\n<br>\n<div>\n  <span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">Warmly,</span>\n</div>\n<div>\n  <span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">The Social Innovation Summit Team</span>\n</div>\n<div>',
        },
        deniedEmail: {
          emailSendFrom: "akalaigian@landmarkventures.com",
          emailSendFromName: "Andrew Kalaigian",
          emailSubject: "SIS 2025 VIP Event Series at capacity",
          emailBody:
            '<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;">Hi {FirstName|"There"},</span>\n<br>\n<br>\n<span style="font-family: arial,helvetica,sans-serif; font-size: 10pt; margin-left: 0px;">Thank you for your interest in joining SIS 2025 VIP Event Series. Unfortunately we are at capacity for this event and so are unable to accomodate you.</span>\n<br>\n<br>\n<div>\n  <span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">Warm regards,</span>\n</div>\n<div>\n  <span style="font-family: arial,helvetica,sans-serif; font-size: 10pt;">Kayla</span>\n</div>\n<div style="font-family: arial,helvetica,sans-serif;">\n  <p>_______________________________________ <br>\n    <strong>Kayla Schoerie</strong>\n    <br>Landmark Ventures | Marketing Coordinator <br> 475 Park Avenue South | New York, NY 10016 <br>\n    <br> Tel: 212.268.8500 | Cell: 203.856.7299 <br>Email: <a href="mailto:kschoerie@landmarkventures.com">kschoerie@landmarkventures.com</a>\n    <u>\n      <br>\n      <a href="https://twitter.com/socinnovation">Twitter</a>\n    </u> | <u>\n      <a href="https://www.instagram.com/socinnovation/">Instagram</a>\n    </u> | <a href="https://www.linkedin.com/company/social-innovation-summit/?viewAsMember=true">LinkedIn</a>\n    <br> _______________________________________\n</div>',
        },
      };

      setPreloadedEvent(preloadedObj);
      setLoading(false);
      return;
    }
    async function getPreloadedEventByTitle(eventTitle, isDynamic = false) {
      try {
        const api = new ApiService();
        const endpoint = isDynamic
          ? `landmark/dynamicEvents/getEventByTitle`
          : `landmark/events/getEventByEventTitle`;
        const response = await api.post(
          endpoint,
          { title: eventTitle }
        );
        console.log(
          `getPreloadedEvent() - ${endpoint}`,
          eventTitle,
          response
        );
        if (response && response.eventId) {
          isDynamic ? setDynamicEvent(response) : setPreloadedEvent(response);
        } else {
          throw "Couldn't get event";
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    // cannes
    if (process.env.REACT_APP_HOMEPAGE === "cannes") {
      console.log(`HOMEPAGE === CANNES - PRELOADING EVENT`);
      const eventTitle = `Cannes 2025`;
      getPreloadedEventByTitle(eventTitle);
    }
    // deal
    else if (process.env.REACT_APP_HOMEPAGE === "deal") {
      console.log(`HOMEPAGE === DEAL - PRELOADING EVENT`);
      const eventTitle = `DEAL 2026`;
      getPreloadedEventByTitle(eventTitle);
    }
    else if (process.env.REACT_APP_HOMEPAGE === "deal2025") {
      console.log(`HOMEPAGE === DEAL2025 - PRELOADING EVENT`);
      const eventTitle = `DEAL 2025`;
      getPreloadedEventByTitle(eventTitle);
    }
    // unga
    else if (process.env.REACT_APP_HOMEPAGE === "unga") {
      console.log(`HOMEPAGE === UNGA - PRELOADING EVENT`);
      const eventTitle = `Social Innovation Summit @ UNGA 2026`;
      getPreloadedEventByTitle(eventTitle);
    }
    else if (process.env.REACT_APP_HOMEPAGE === "unga25") {
      console.log(`HOMEPAGE === UNGA25 - PRELOADING EVENT`);
      const eventTitle = `UNGA 2025`;
      getPreloadedEventByTitle(eventTitle);
    }
    // sisvip
    else if (process.env.REACT_APP_HOMEPAGE === "sisvip") {
      console.log(`HOMEPAGE === SISVIP - PRELOADING EVENT`);
      const eventTitle = `Social Innovation Summit 2026 VIP Event Series`;
      getPreloadedEventByTitle(eventTitle);
      // getPreloadedEventSisVip();
    }
    else if (process.env.REACT_APP_HOMEPAGE === "sisvip25") {
      console.log(`HOMEPAGE === SISVIP25 - PRELOADING EVENT`);
      const eventTitle = `SIS 2025 VIP Event Series`;
      getPreloadedEventByTitle(eventTitle);
    }
    // giis
    else if (process.env.REACT_APP_HOMEPAGE === "giis") {
      console.log(`HOMEPAGE === GIIS - PRELOADING EVENT`);
      const eventTitle = `The Global-Israel Innovation Summit at RSA`;
      getPreloadedEventByTitle(eventTitle, true);
      // getPreloadedEventSisVip();
    }
    // rsa
    else if (process.env.REACT_APP_HOMEPAGE === "rsa") {
      console.log(`HOMEPAGE === RSA - PRELOADING EVENT`);
      const eventTitle = `RSA`;
      getPreloadedEventByTitle(eventTitle);
    }
    // blackhat
    else if (process.env.REACT_APP_HOMEPAGE === "blackhat") {
      console.log(`HOMEPAGE === BLACKHAT - PRELOADING EVENT`);
      const eventTitle = `BlackHat`;
      getPreloadedEventByTitle(eventTitle);
    }
  }, []);

  useEffect(() => {
    async function getDynamicEvent() {
      try {
        const pageUrlAliases = {
          "broadcom-chicago-2026": "broadcom-chicago",
        };
        const fullPageUrl = location.pathname.slice(1).toLowerCase().trim(); // remove leading /
        let pageUrl;
        let referral;
        try {
          pageUrl = fullPageUrl.split("/")[0];
          referral = fullPageUrl.split("/")[1];
        } catch (error) {}
        const normalizedPageUrl = (pageUrl || "").toLowerCase().trim();
        const canonicalPageUrl =
          pageUrlAliases[normalizedPageUrl] || normalizedPageUrl;
        const api = new ApiService();
        console.log(
          `getDynamicEvent() - pageUrl`,
          normalizedPageUrl,
          `canonicalPageUrl`,
          canonicalPageUrl
        );
        let event;
        const fallbackEvent = cloneDynamicEventFallback(canonicalPageUrl);
        if (fallbackEvent) {
          const fetchEventPromise = api.post(
            `landmark/dynamicEvents/getEventByPageUrl`,
            { pageUrl: canonicalPageUrl }
          );
          const timeoutPromise = new Promise((_, reject) => {
            setTimeout(() => {
              reject(
                new Error(
                  `Timed out after ${DYNAMIC_EVENT_REQUEST_TIMEOUT_MS}ms while fetching dynamic event`
                )
              );
            }, DYNAMIC_EVENT_REQUEST_TIMEOUT_MS);
          });
          try {
            event = await Promise.race([fetchEventPromise, timeoutPromise]);
          } catch (error) {
            console.warn(
              `getDynamicEvent() - API request failed/timed out for ${canonicalPageUrl}. Falling back to hardcoded event.`,
              error
            );
            event = fallbackEvent;
          }
        } else {
          event = await api.post(`landmark/dynamicEvents/getEventByPageUrl`, {
            pageUrl: canonicalPageUrl,
          });
        }
        console.log(
          `getDynamicEvent() - landmark/dynamicEvents/getEventByPageUrl`,
          event
        );
        if (event && event.pageUrl) {
          // dynamic event for this page url has been found
          setDynamicEvent(event);
          setDynamicEventRoutePageUrl(normalizedPageUrl);
          console.log(`Dynamic Event for this page url has been found`);
          console.log(`setDynamicEvent()`, event);

          if (referral) {
            // console.log(`possible referral detected - ${referral}`);
            // possible referral url - check event to see if the referral url is included
            if (event.referralUrls && event.referralUrls.length) {
              const eventReferral = event.referralUrls.find(
                (r) =>
                  r.url.toLowerCase().trim() === referral.toLowerCase().trim()
              );
              if (eventReferral) {
                console.log(`referral: ${eventReferral.name}`);
                setDynamicEventReferral({
                  url: eventReferral.url,
                  name: eventReferral.name,
                });
              }
            }
          } else {
            // console.log(`no referral detected`);
          }
          // setUser(response);
        } else {
          throw `Couldn't get dynamic event by pageUrl`;
        }
      } catch (error) {
        console.log(`error`, error);
      } finally {
        setLoading(false);
      }
    }

    // user is on events client (or running locally!) & pathname is not empty (page is not index)
    if (!process.env.REACT_APP_HOMEPAGE && location.pathname.length > 1) {
      console.log(
        `User is on events client and page is not index (${location.pathname}) - getting dynamic event`
      );
      getDynamicEvent();
    }
    else {
      // We have a HOMEPAGE set (e.g., "sisdelegate") or we're on index — no dynamic fetch
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    try {
      // Get the current URLSearchParams object from the window.location
      const params = new URLSearchParams(window.location.search);

      // Create an empty object to store the parsed parameters
      const parsedParams = {};

      // Loop through all the URL parameters and store them in the parsedParams object
      for (const [key, value] of params.entries()) {
        parsedParams[key] = value;
      }

      // set cookies
      const userId = parsedParams["u"];
      if (userId) {
        console.log(`setting userId cookie`, userId);
        setCookie("userId", userId);
        setUserId(userId);
      }

      // Set the parsed parameters in the state
      setUrlParams(parsedParams);
    } catch (error) {
      console.log(`error`, error);
    }
  }, []);

  useEffect(() => {
    async function getUserInfo() {
      try {
        const api = new ApiService();
        const response = await api.get(
          `landmark/contacts/getContact/${userId}`
        );
        console.log(
          `getUserInfo() - landmark/contacts/getContact/${userId}`,
          response
        );
        if (response && response.contactId) {
          setUser(response);
        } else {
          throw `Couldn't get user from userId ${userId}`;
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    }
    if (userId) {
      getUserInfo();
    }
  }, [userId]);

  // Render the component based on the value of `HOMEPAGE` env variable
  const renderHomepage = () => {
    if (homepage === "industrialtech") {
      return <IndustrialTech />;
    } else if (homepage === "industrial") {
      return <IndustrialTechNew user={user} />;
    } else if (homepage === "dealmakersib") {
      return <DealmakersIB />;
    } else if (homepage === "israeldealportal") {
      return <IsraelDealPortal />;
    } else if (homepage === "sisomni") {
      return <SisOmni />;
    } else if (homepage === "sisdelegate") {
      return <SisDelegate />;
    } else if (homepage === "ces") {
      // return <RedirectToExternalURL url="https://landmarkventures.com" />;
      return <CES />;
    } else if (homepage === "unga") {
      return <UNGA />;
    }
    else if (homepage === "unga25") {
      return <UNGA25 />;
    }
    else if (homepage === "cannes") {
      return <Cannes />;
    }
    else if (homepage === "deal") {
      return <DEAL />;
    }
    else if (homepage === "deal2025") {
      return <DEAL2025 />;
    }
     else if (homepage === "sisvip") {
      return <SISVIP />;
    } else if (homepage === "sisvip25") {
      return <SISVIP25 />;
    } else if (homepage === "leadgen") {
      return <LeadGen />;
    } else if (homepage === "leadmagic") {
      return <LeadMagic />;
    } else if (homepage === "ourevents") {
      return <OurEvents />;
    }
    else if (homepage === "rsa") {
      return <RSA />;
    }
    else if (homepage === "blackhat") {
      return <Blackhat />;
    }
    else if(homepage === "giis") {
      if(dynamicEvent && dynamicEvent.title) {
        return <GIIS event={dynamicEvent} />;
      } else {
        return <LoadingPage />;
      }
    }
    // events.landmarkventures.com homepage (also for dynamic)
    else {
      return <Events />;
    }
  };
  let shouldShowHeader = true;
  let shouldShowFooter = true;
  let headerProps = {
    sticky: true,
    transparent: false,
    cssClass: "position-fixed",
  };
  let footerProps = {
    backgroundColor: `#ffffff`,
    fullLengthDivider: false,
  };

  const isOnPage = (page) => {
    if (
      window.location.pathname
        .toLowerCase()
        .includes(`/${page.toLowerCase()}`) ||
      homepage === page.toLowerCase()
    ) {
      return true;
    }
    return false;
  };

  // const isOnDynamicPage = (page) => {
  //   if (
  //     window.location.pathname.includes(page.toLowerCase()) ||
  //     homepage === page.toLowerCase()
  //   ) {
  //     return true;
  //   }
  //   return false;
  // };
  // this checks the env variables to determine which page is being rendered
  // let shouldShowHeaderFooter =
  //   homepage !== "sisdelegate" && homepage !== "leadgen";
  // however when running locally env variables may not be set, in which case check pathname
  if (
    isOnPage("sisdelegate") ||
    isOnPage("leadgen") ||
    isOnPage("unga") ||
    isOnPage("unga25") ||
    isOnPage("sisvip") ||
    isOnPage("sisvip25") ||
    isOnDynamicEventPage
  ) {
    shouldShowHeader = false;
    shouldShowFooter = false;
  }
  if (
    isOnPage("ces") ||
    isOnPage("israeldealportal") ||
    isOnPage("industrial")
  ) {
    shouldShowHeader = true;
    shouldShowFooter = false;
    headerProps = { transparent: true, cssClass: "ces-header", sticky: false };
  }

  if (
    isOnPage("cannes") ||
    isOnPage("deal") ||
    isOnPage("rsa") ||
    isOnPage("blackhat")
  ) {
    shouldShowHeader = false;
    shouldShowFooter = false;
    footerProps = {
      backgroundColor: `#F2F2F2`,
      fullLengthDivider: true,
    };
  }

  console.log(`shouldShowHeader`, shouldShowHeader);
  console.log(`shouldShowFooter`, shouldShowFooter);

  if (loading) {
    return <LoadingPage />; // Display loading component while fetching data
  }

  return (
    <>
      <Toaster
        containerStyle={{
          top: 100,
        }}
        toastOptions={{
          style: {
            background: "#175d8c",
            color: "#fff",
          },
        }}
      />
      {shouldShowHeader && <Header headerProps={headerProps} />}
      <div
        className={
          "main " +
          (leadPage ||
          isOnDynamicEventPage ||
          isOnPage("sisvip") ||
          isOnPage("sisvip25") ||
          (isOnPage("unga") && !isOnPage("unga25"))
            ? "removeP"
            : "")
        }
      >
        <Routes>
          {/* preloaded sisvip event */}
          {preloadedEvent &&
          preloadedEvent.title
            .toLowerCase()
            .includes("social innovation summit 2026 vip event series") ? (
            <Route path="" element={<SISVIP event={preloadedEvent} />} />
          ) : null}
          {/* preloaded sisvip25 event */}
          {preloadedEvent && homepage === "sisvip25" ? (
            <Route path="" element={<SISVIP25 event={preloadedEvent} />} />
          ) : null}
          {/* preloaded cannes event */}
          {preloadedEvent && preloadedEvent.title.toLowerCase().includes("cannes") ? (
            <Route path="" element={<Cannes event={preloadedEvent} />} />
          ) : null}
          {/* preloaded unga25 event */}
          {preloadedEvent && preloadedEvent.title.toLowerCase().includes("unga 2025") ? (
            <Route path="" element={<UNGA25 event={preloadedEvent} />} />
          ) : null}
          {/* preloaded unga event */}
          {preloadedEvent && preloadedEvent.title.toLowerCase().includes("unga") ? (
            <Route path="" element={<UNGA event={preloadedEvent} />} />
          ) : null}
          {/* preloaded deal event */}
          {preloadedEvent && preloadedEvent.title.toLowerCase().includes("deal 2025") ? (
            <Route path="" element={<DEAL2025 event={preloadedEvent} />} />
          ) : preloadedEvent && preloadedEvent.title.toLowerCase().includes("deal") ? (
            <Route path="" element={<DEAL event={preloadedEvent} />} />
          ) : null}
          {/* preloaded rsa event */}
          {preloadedEvent && preloadedEvent.title.toLowerCase().includes("rsa") ? (
            <Route path="" element={<RSA event={preloadedEvent} />} />
          ) : null}
          {/* preloaded blackhat event */}
          {preloadedEvent &&
          preloadedEvent.title.toLowerCase().includes("blackhat") ? (
            <Route path="" element={<Blackhat event={preloadedEvent} />} />
          ) : null}
         
          {!preloadedEvent ? (
            <Route path="" element={renderHomepage()} />
          ) : null}
          <Route path="events" element={<Events />} />
          <Route path="ourevents" element={<OurEvents />} />

          <Route path="ces" element={<CES />} />
          {/* Redirect "ces" path to external site */}
          {/* <Route
            path="ces"
            element={
              <RedirectToExternalURL url="https://landmarkventures.com" />
            }
          /> */}
          <Route path="ces2025" element={<CES />} />

          <Route path="unga" element={<UNGA event={preloadedEvent} />} />
          <Route path="unga25" element={<UNGA25 event={preloadedEvent} />} />
          <Route path="sisvip" element={<SISVIP event={preloadedEvent} />} />
          <Route path="sisvip25" element={<SISVIP25 />} />
          <Route path="cannes" element={<Cannes event={preloadedEvent} />} />
          <Route path="deal" element={<DEAL event={preloadedEvent} />} />
          <Route path="deal2025" element={<DEAL2025 event={preloadedEvent} />} />
          <Route path="rsa" element={<RSA event={preloadedEvent} />} />
          <Route path="blackhat" element={<Blackhat event={preloadedEvent} />} />
          <Route path="industrialtech" element={<IndustrialTech />} />
          <Route
            path="industrial"
            element={<IndustrialTechNew user={user} />}
          />
          <Route path="dealmakersib" element={<DealmakersIB />} />
          <Route path="israeldealportal" element={<IsraelDealPortal />} />
          <Route path="sisomni" element={<SisOmni />} />
          <Route path="sisdelegate" element={<SisDelegate />} />
          <Route
            path="leadgen1"
            element={
              <LeadGen
                setChangeHead={setChangeHead}
                setLeadPage={setLeadPage}
              />
            }
          />
          <Route
            path="leadgen2"
            element={
              <LeadMagic
                setChangeHead={setChangeHead}
                setLeadPage={setLeadPage}
              />
            }
          />
          {/* dynamic events */}
          {dynamicEvent ? (
            <Route
              path={dynamicEventRoutePageUrl || dynamicEvent.pageUrl}
              element={
                <EventsDynamic
                  event={dynamicEvent}
                  activePageUrl={dynamicEventRoutePageUrl || dynamicEvent.pageUrl}
                />
              }
            />
          ) : null}
          {/* dynamic event with referral */}
          {dynamicEvent && dynamicEventReferral && dynamicEventReferral.url ? (
            <Route
              path={`${
                dynamicEventRoutePageUrl || dynamicEvent.pageUrl
              }/${dynamicEventReferral.url}`}
              element={
                <EventsDynamic
                  event={dynamicEvent}
                  referral={dynamicEventReferral}
                  activePageUrl={dynamicEventRoutePageUrl || dynamicEvent.pageUrl}
                />
              }
            />
          ) : null}
        </Routes>
      </div>
      <Analytics />
      {shouldShowFooter && <Footer footerProps={footerProps} />}
    </>
  );
}
